<template>
    <b-modal
        no-fade
        ref="dialog"
        title-tag="h2"
        title="Email Order"
        lazy
        no-enforce-focus
        no-close-on-backdrop
        no-close-on-esc
    >
        <form>
            <b-form-group label-cols="2" label="To:" label-for="to">
                <vue-select
                    v-model="recipient"
                    clearable
                    class="show-actions"
                    multiple
                    name="recipient"
                    :options="recipientOptionsFiltered"
                    :getOptionLabel="recipientLabel"
                    placeholder="To (required)"
                >
                    <div slot="option" slot-scope="option">
                        <span style="white-space: normal;">
                            {{ option.name }}
                            <br />
                            <span style="font-size: 0.9em;">
                                ({{ option.email }})
                            </span>
                        </span>
                    </div>
                </vue-select>
            </b-form-group>
            <b-form-group label-cols="2" label="Subject:" label-for="subject">
                <b-form-input
                    :disabled="isLoadingContent"
                    v-model="subject"
                    placeholder="Subject (required)"
                    v-validate="'required'"
                    name="subject"
                    :class="{
                        'border-danger': errors.has('recipient')
                    }"
                />
            </b-form-group>
            <b-form-group label-cols="2" label="Message:" label-for="message">
                <content-editable
                    :disabled="isLoadingContent"
                    id="message"
                    v-model="message"
                    :noHTML="false"
                    tag="div"
                    class="form-control"
                    placeholder="Message (required)"
                    name="message"
                    v-validate="'required'"
                    :class="{
                        'border-danger': errors.has('message')
                    }"
                />
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isSending" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isSending"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isSending"
                variant="primary"
                @click="send"
                :disabled="disableSendButton"
            >
                Send
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ContentEditable from "vue-contenteditable/src/contenteditable.vue";
import VueSelect from "vue-select";
import Loader from "@/module/commons/loader";

export default {
    components: {
        ContentEditable,
        VueSelect,
        Loader
    },
    data() {
        return {
            orderId: null,
            recipient: [],
            recipientComponentKey: 0,
            isLoadingEmailDefault: true,
            subject: "",
            message: "",
            recipientOptions: [],
            isSending: false,
            isLoadingContent: true
        };
    },
    computed: {
        recipientOptionsFiltered() {
            let res = this.recipientOptions;
            res = res.filter(contact => contact.email !== "" && contact.email);

            for (let chosen of this.recipient) {
                res = res.filter(contact => contact.email !== chosen.email);
            }

            return res;
        },
        disableSendButton() {
            if (
                this.recipient.length === 0 ||
                this.subject === "" ||
                this.message === ""
            ) {
                return true;
            }

            return false;
        }
    },
    methods: {
        open({
            orderId,
            orderIndex,
            businessName,
            businessPhone,
            supplierName,
            supplierEmail,
            supplierId
        }) {
            this.orderId = orderId;
            this.recipient = [
                {
                    name: supplierName,
                    email: supplierEmail,
                    id: supplierId
                }
            ];

            this.$refs.dialog.show();
            this.fetchRecipientOptions();
            this.fetchEmailDetails({
                orderId,
                orderIndex,
                businessName,
                businessPhone
            });
        },
        async fetchEmailDetails({
            orderId,
            orderIndex,
            businessName,
            businessPhone
        }) {
            this.isLoadingContent = true;

            let res = await this.$http.get(
                `${process.env.BARRAMUNDI}inventory/order/email/${orderId}`
            );

            this.isLoadingContent = false;

            if (res.data && res.data.response && res.data.response.resources) {
                let { subject, message } = res.data.response.resources;
                this.subject = subject;
                this.message = message;
            } else {
                // default
                this.subject = `Purchase Order #${orderIndex} from ${businessName}`;
                this.message = `<p>Dear Sir/Madam:</p><p>Enclosed please find Purchase Order #${orderIndex} from ${businessName}. If you have any questions, please contact us at ${businessPhone}.</p><p>Thank you,</p><p>${businessName}</p>`;
            }
        },
        async fetchRecipientOptions() {
            let res = await this.$http.get(
                `${process.env.BARRAMUNDI}account/contacts`
            );

            if (res.data.response && res.data.response.resources) {
                this.recipientOptions = res.data.response.resources;
            }
        },
        async send() {
            try {
                let recipientIds = [];

                for (let rec of this.recipient) {
                    recipientIds.push(rec.id);
                }

                let data = {
                    purchase_order_id: this.orderId,
                    to: recipientIds,
                    subject: this.subject,
                    message: this.message
                };

                this.isSending = true;

                let res = await this.$http.post(
                    `${process.env.BARRAMUNDI}inventory/order/send-email`,
                    data
                );

                if (
                    res.data &&
                    res.data.response &&
                    res.data.response.message &&
                    res.data.response.message.errors
                ) {
                    throw new Error("Error: Unable to send email");
                }

                this._message("Email sent");
                this.$refs.dialog.hide();
            } catch (err) {
                this.isSending = false;
                this._message(err.message, "danger");
            }
        },
        recipientLabel(record) {
            return `${record.name} (${record.email})`;
        }
    }
};
</script>
